import Active from './active';
import Disable from './disable';
const CloseButton = { Active, Disable };

export default CloseButton;
